<script lang="ts">
    import BackButton from "../shared/BackButton.svelte";
    import {gtag} from "../utils";

    gtag('set', 'page_path', '/informacio');
    gtag('event', 'page_view');
</script>
<svelte:head>
    <title>Roses UPC - Saber-ne més</title>
</svelte:head>

<BackButton fallbackPath="/"/>

<h1> Com es generen les roses UPC?</h1>

<p>
    Internament, es fan servir dos models de xarxes neuronals, un dels quals és capaç de generar les imatges, mentre que
    l’altre valora fins a quin punt una imatge coincideix amb l’estil artístic i el nostre missatge de text. Aquesta
    interacció guia el nostre generador per produir imatges més precises.
</p>

<p>
    Per exemple: d'una banda tenim un text que descriu la imatge com “Una rosa vermella” i, de l'altra, un text
    que indica a què volem que s’assembli. Per exemple: “Surrealisme bonic per Salvador Dalí”
</p>

<p>
    En la primera iteració, el nostre model atorgarà les següents probabilitats a la descripció de la imatge:
</p>

<img src="/img/info/rose.png" alt="Rosa">

<ul>
    <li>“Una rosa vermella”: 100 %</li>
    <li>“Surrealisme bonic per Salvador Dalí”: 0,5 %</li>
</ul>

<p>
    L’algorisme iteratiu anirà modificant la imatge de tal manera que les probabilitats que la imatge obtinguda es
    correspongui amb les dues frases siguin les màximes possibles. Per exemple, després d’unes quantes iteracions, les
    probabilitats podrien ser les següents:
</p>

<ul>
    <li>“Una rosa vermella”: 95 %</li>
    <li>“Surrealisme bonic per Salvador Dalí”: 12 %</li>
</ul>

<p>
    Les imatges següents mostren l'evolució en la creació d'una de les roses UPC 2022:
</p>

<div id="image-div">
    <img src="/img/info/rose.png" alt="Rosa Inicial">
    <img src="/img/info/mid.png" alt="Rosa Intermitja">
    <img src="/img/info/final.png" alt="Rosa Final">
</div>

<p>
    Les roses UPC s'han generat a partir del treball en codi obert de Katherine Crowson (
    <a href="https://github.com/crowsonkb" target="_blank" class="text-link">https://github.com/crowsonkb</a>) basat en
    el mètode VQGAN+CLIP original (
    <a href="https://twitter.com/advadnoun" target="_blank" class="text-link">https://twitter.com/advadnoun</a>).
    <br>
    Les roses UPC es poden distribuir lliurement sense fer-ne un ús comercial sota la llicència
    <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" class="text-link">Creative Commons
        CC BY-NC-ND 4.0</a>.
</p>
<h2>
    T'interessen els estudis relacionats amb la informàtica i la intel·ligència artificial?
</h2>

<p>
    La UPC ofereix una estimulant oferta d’estudis de grau que tracten els diversos aspectes de la tecnologia que fan
    possible un projecte com Roses UPC.
</p>

<!--<a href="https://www.fib.upc.edu/ca/estudis/graus/grau-en-enginyeria-informatica" target="_blank">-->
<!--    <h4 class="text-link">-->
<!--        Grau en Enginyeria Informàtica-->
<!--    </h4>-->
<!--</a>-->
<!--<a href="https://www.fib.upc.edu/ca/estudis/graus/grau-en-intelligencia-artificial" target="_blank">-->
<!--    <h4 class="text-link">-->
<!--        Grau en Intel·ligència Artificial-->
<!--    </h4>-->
<!--</a>-->
<!--<a href="https://www.fib.upc.edu/ca/estudis/graus/grau-en-ciencia-i-enginyeria-de-dades" target="_blank">-->
<!--    <h4 class="text-link">-->
<!--        Grau en Ciència i Enginyeria de Dades-->
<!--    </h4>-->
<!--</a>-->

<a href="https://www.upc.edu/ca/graus/" target="_blank" class="text-link large-link">
    <!--        Consulta la informació sobre aquests estudis i més-->
    Consulta la informació sobre els estudis de la UPC.
</a>

<h2>Sobre l'inLab FIB</h2>
<p>
    L’inLab FIB és el laboratori d’innovació i recerca de la Facultat d’Informàtica de Barcelona de la UPC. Està
    especialitzat en el desenvolupament de projectes R+D+i multidisciplinars a l'àmbit de les tecnologies de la
    informació, tant per a entitats públiques com privades.
</p>

<a href="https://inlab.fib.upc.edu/" target="_blank" class="text-link large-link">
    Per saber més sobre l'inLab FIB
</a>


<h2>Sobre UPCArts</h2>
<p>
    UPCArts és un programa d'activitats culturals per a tota la comunitat UPC que estableix ponts i aliances entre les
    ciències i la tecnologia amb l’art i la cultura. #RosaUPC22 ajuda a apropar la mirada artística i la tecnològica.
</p>

<a href="https://www.upc.edu/ca/upcarts" target="_blank" class="text-link large-link">
    Per saber més sobre UPCArts
</a>


<style>
    h1 {
        border-top: 3px solid var(--main-color);
        margin-top: 0;
        padding-top: 15px;
        color: var(--main-color);
        font-size: 2.5em;
        font-weight: 500;
    }

    .large-link {
        font-weight: 500;
        font-size: 1.17em;
    }

    img {
        max-width: 19vw;
    }

    @media (max-width: 1000px) {

        #image-div {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 5px;
        }

        img {
            max-width: none;
        }

    }

</style>